import { render, staticRenderFns } from "./EditSpeakerDetails.vue?vue&type=template&id=12cf5616"
import script from "./EditSpeakerDetails.vue?vue&type=script&lang=js"
export * from "./EditSpeakerDetails.vue?vue&type=script&lang=js"
import style0 from "./EditSpeakerDetails.vue?vue&type=style&index=0&id=12cf5616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports